import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const navigate  = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.login(username, password);
      login(data.token);
      navigate('/fichas', { replace: true });
    } catch (err) {
      setError(err.message || 'Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BgStyle />
      <Page>
        <Box>
          <Logo src="/img/logo/grupojaycom_logo.png" alt="Grupo Jaycom" />
          <Title>Fichas Técnicas</Title>
          <Subtitle>Acceso privado</Subtitle>

          <Form onSubmit={handleSubmit}>
            <Field>
              <Label>Usuario</Label>
              <Input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="usuario"
                autoFocus
                autoComplete="username"
                required
              />
            </Field>
            <Field>
              <Label>Contraseña</Label>
              <Input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
            </Field>
            {error && <ErrorMsg>{error}</ErrorMsg>}
            <SubmitBtn type="submit" disabled={loading}>
              {loading ? 'Entrando…' : 'Entrar'}
            </SubmitBtn>
          </Form>
        </Box>
      </Page>
    </>
  );
}

const BgStyle = createGlobalStyle`
  body { background: var(--blue-dk) !important; }
`;

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

const Box = styled.div`
  background: white;
  border-radius: 10px;
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 12px 48px rgba(0,0,0,0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
`;

const Logo = styled.img`
  height: 52px;
  object-fit: contain;
  margin-bottom: 0.75rem;
`;

const Title = styled.h1`
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.6rem;
  color: var(--blue);
  letter-spacing: 0.06em;
`;

const Subtitle = styled.p`
  font-size: 0.78rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-sub);
  margin-bottom: 1rem;
`;

const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

const Label = styled.label`
  font-size: 0.72rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-sub);
`;

const Input = styled.input`
  border: none;
  border-bottom: 2px solid var(--border);
  background: transparent;
  padding: 0.55rem 0;
  font-size: 0.95rem;
  font-family: 'Inter', sans-serif;
  color: var(--text);
  outline: none;
  transition: border-color 0.2s;
  &:focus { border-color: var(--blue); }
  &::placeholder { color: var(--text-sub); opacity: 0.4; }
`;

const ErrorMsg = styled.p`
  font-size: 0.82rem;
  color: var(--red);
  margin: 0;
`;

const SubmitBtn = styled.button`
  margin-top: 0.5rem;
  padding: 0.75rem;
  background: var(--blue);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  &:hover:not(:disabled) { background: var(--blue-dk); }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;
